import { defineComponent } from "vue";

/**
 * 渲染 `Task` SVG 图标。
 *
 * @remarks
 * Vue 透传属性（如 `class`、`style`、`role`、`aria-label`、`width`、`height` 和 `fill`）会应用到根 `<svg>` 元素。
 */
export const Task = defineComponent({
	name: "Task",
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
				<path d="M750.1 958.2c-115.4 0-209.2-93.8-209.2-209.2 0-115.4 93.8-209.2 209.2-209.2S959.3 633.6 959.3 749c0 115.3-93.8 209.2-209.2 209.2z m0-332.5c-67.9 0-123.2 55.3-123.2 123.2s55.3 123.2 123.2 123.2 123.2-55.3 123.2-123.2-55.2-123.2-123.2-123.2z" />
				<path d="M649.4 926.7H152.7c-30.3 0-55-24.7-55-55V151.9c0-30.3 24.7-55 55-55h719.8c30.3 0 55 24.7 55 55V661h-86V182.9H183.7v657.8h465.6v86z" />
				<path d="M718.9 387.3H306.3c-23.7 0-43-19.3-43-43s19.3-43 43-43h412.5c23.7 0 43 19.3 43 43s-19.2 43-42.9 43zM515 603.6H306.3c-23.7 0-43-19.3-43-43s19.3-43 43-43H515c23.7 0 43 19.3 43 43s-19.2 43-43 43z" />
				<path d="M391.2 646.2c-23.7 0-43-19.3-43-43V518c0-23.7 19.3-43 43-43s43 19.3 43 43v85.2c0 23.8-19.2 43-43 43zM618 429.9c-23.7 0-43-19.3-43-43v-85.2c0-23.7 19.3-43 43-43s43 19.3 43 43v85.2c0 23.8-19.3 43-43 43zM837 743.1c-3.4-23.5-25.2-39.8-48.7-36.4l-20 2.9-31.1-31.1c-16.8-16.8-44-16.8-60.8 0-16.8 16.8-16.8 44 0 60.8l46.3 46.3c8.4 8.4 19.4 12.6 30.4 12.6 2.4 0 4.9-0.2 7.3-0.6 0.9-0.1 1.7-0.2 2.6-0.3l37.6-5.4c23.5-3.5 39.8-25.3 36.4-48.8z" />
			</svg>
		);
	},
});

export default Task;
